import React, { useEffect, useState } from "react";

import { useFetch } from "use-http";

import { db } from "../../lib/firebaseCompat"

import EstimateTr from "./EstimateTr";
import EstimateTdUpdatedAt from "./EstimateTdUpdatedAt";
import EstimateTdDownload from "./EstimateTdDownload";
import EstimateTdUnarchive from "./EstimateTdUnarchive";
import Layout from "../shared/Layout";
import CardSearchTable from "../shared/CardSearchTable";
import { archivedTableHeaders } from "../../helpers/estimateTableHeaders";
import { formattedCost } from "../../helpers/formatters";

import { useOrganization } from "../../hooks/useOrganization";
import { useAuth } from "../../hooks/usehooks.com/use-auth";

const tooltip = `These archived estimates are no longer listed in your estimates. You can unarchive these to return them to your estimates. To view the estimate details, click the business name.`;

const columns = archivedTableHeaders();
const columnNames = columns.map((c) => c.name);
const cardSearchPropDefaults = {
  columns,
  tooltip,
  header: "Archived Estimates",
  placeholder: "Search by Business Name, Industry, or NAICS Code",
  empty: "No archived estimates found.",
};
const initialPageLimit = 30;

export default function Archived() {
  const { user } = useAuth();
  const organization = useOrganization();
  const [estimates, setEstimates] = useState([]);
  const [searchTerm, setSearchTerm] = useState();
  const [pageLimit, setPageLimit] = useState(initialPageLimit);

  const orgId = organization.current?.id;

  const onSubmit = ({ search }) => {
    const term = search.toLowerCase();
    console.log(term);
    setSearchTerm(term);
  };

  const onLoadMore = () => {
    setPageLimit(pageLimit + initialPageLimit);
  };
  const page = {
    records: estimates.length,
    initial: initialPageLimit,
    current: pageLimit,
  };

  const cardSearchProps = {
    onSubmit,
    onLoadMore,
    page,
    ...cardSearchPropDefaults,
  };

  useEffect(() => {
    if (!orgId) {
      return;
    }
    const ref = db
      .collection("organizations")
      .doc(orgId)
      .collection("estimates");
    const query = ref
      .where("createdBy", "==", user.uid)
      .where("archived", "==", true)
      .orderBy("updatedAt", "desc")
      .limit(pageLimit);

    const search = searchTerm
      ? query.where("indexSearchTerms", "array-contains", searchTerm)
      : query;

    const subscribe = (snapshot) => {
      const docs = snapshot.docs.map((doc) => {
        const estimate = { id: doc.id, ...doc.data() };
        return { estimate };
      });
      setEstimates(docs);
    };

    const unsubscribe = search.onSnapshot(subscribe);

    return unsubscribe;
  }, [db, orgId, pageLimit, searchTerm]);

  return (
    <Layout>
      <CardSearchTable {...cardSearchProps}>
        {estimates.map(({ estimate }) => {
          return (
            <tr key={estimate.id}>
              <EstimateTdUpdatedAt updatedAt={estimate.updatedAt.toDate()} />
              <td>{estimate.naics}</td>
              <td>{estimate.industryName}</td>
              <td>{estimate.businessName}</td>
              <td>{estimate.year}</td>
              <td>{estimate.employees}</td>
              <td>{formattedCost(Math.floor(estimate.total))}</td>
              <EstimateTdDownload docId={estimate.id} orgId={orgId} />
              <EstimateTdUnarchive docId={estimate.id} orgId={orgId} />
            </tr>
          );
        })}
      </CardSearchTable>
    </Layout>
  );
}
